import React from 'react';

import { createStyles, withStyles, Theme, Grid } from '@material-ui/core';

import commonStyles from '../../common/common.module.css';
import styles from '../analytics.module.css';

import AnalyticsFromToDate from '../../common/AnalyticsFromToDate';
import Filter from "../../common/AnalyticsFilters";
import Average from './Average';
import Query from './Query';
import GraphDataView from './GraphDataView';

import CustomerWaitAverage, { CustomerWaitQuery, filterOptions, UserData } from '../../../models/Analytics';
import { Moment } from 'moment';
import AirlineType from '../../../models/AirlineType';
import ForwarderModel from '../../../models/ForwarderAwb';
import { CustomerWaitGraphData } from '../../../models/Analytics';
import DeliveryCompany from '../../../models/DeliveryCompany';

const materialStyles = (theme: Theme) =>
  createStyles({

  });

interface customerWaitTimeProps {
  classes: any;
  type: string;
  average: CustomerWaitAverage;
  startDate: Moment;
  endDate: Moment;
  progress: boolean;
  pickUp: boolean;
  dropOff: boolean;
  error: boolean;
  appt: boolean;
  carrCheck: boolean;
  carr: string;
  day_diff: number;
  fwd_id: number;
  trk_cmp: number;
  intvl: number;
  drv_name: string;
  gha_id: number;
  query: CustomerWaitQuery;
  filterOptions: filterOptions;
  avgData: Array<any>;
  queryResult: number;
  airlines: Array<AirlineType>;
  forwarders: Array<ForwarderModel>;
  companies: DeliveryCompany[];
  drivers: Array<string>;
  users: UserData[];
  graphData: CustomerWaitGraphData;
  dataView: boolean;
  handleChangeDataView: (value: boolean) => void;
  handleChangeDate: (dateType: string, event: any) => void;
  handleChangeQuery: (type: string, comp: string, value: number) => void;
  handleChangeProcess: (type: string, value: boolean) => void;
  handleChangeCarriers: (type: string, value: boolean) => void;
  handleChangeOption: (type: string, event: any) => void;
  handleChange: (type: string, event: any) => void;
  handleExport: () => void;
  exceedHours?: number;
  handleExceedHoursChange: (value: number) => void;
};



const customerWaitTime = (props: customerWaitTimeProps) => {
  const { type, intvl, forwarders, companies, drivers, users, filterOptions, airlines, day_diff, average, avgData, graphData, startDate, endDate, progress, pickUp, dropOff, error, appt, carr, fwd_id, trk_cmp, drv_name, gha_id, query, queryResult, dataView, handleChangeDataView, handleChangeQuery, handleChangeDate, handleChangeProcess, handleChangeCarriers, handleChangeOption, handleChange, handleExport } = props;

  return (
    <div className={`${commonStyles.mt4} ${commonStyles.positionRelative}`}>
      <AnalyticsFromToDate startDate={startDate} endDate={endDate} progress={progress} handleChangeDate={handleChangeDate} />
      <Grid container spacing={4} className={`${styles.customerGridContainer}`}>
        <Grid item className={`${styles.customerGridItemsFilter}`}>
          <Filter
            pickUp={pickUp}
            dropOff={dropOff}
            error={error}
            appt={appt}
            carrCheck={props.carrCheck}
            carr={carr}
            fwd_id={fwd_id}
            trk_cmp={trk_cmp}
            drv_name={drv_name}
            gha_id={gha_id}
            airlines={airlines}
            users={users}
            forwarders={forwarders}
            companies={companies}
            drivers={drivers}
            filterOptions={filterOptions}
            handleChangeProcess={handleChangeProcess}
            handleChangeCarriers={handleChangeCarriers}
            handleChangeOption={handleChangeOption}
            handleExceedHoursChange={props.handleExceedHoursChange}
            exceedHours={props.exceedHours}
          />
        </Grid>

        <Grid item className={`${styles.customerGridItemsData}`}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Average average={average} type={type} handleChange={handleChange} />
            </Grid>
            <Grid item xs={12}>
              <Query query={query} queryResult={queryResult} handleChangeQuery={handleChangeQuery} />
            </Grid>
            <Grid item xs={12}>
              <GraphDataView day_diff={day_diff} dataView={dataView} intvl={intvl} handleExport={handleExport} handleChange={handleChange} handleChangeDataView={handleChangeDataView} avgData={avgData} graphData={graphData} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(materialStyles)(customerWaitTime);